// extracted by css-extract-rspack-plugin
export default {"recentlyViewed":"_bbb2c523"};